<template>
  <div class="loan-detail">
    <el-card class="loan-detail__card" shadow="never">
      <div slot="header" class="loan-detail__header">
        <div class="loan-detail__title">
          Chi tiết hồ sơ vay vốn khách hàng:
          <b>{{ data.payer_name }}</b>
        </div>
      </div>

      <el-tabs v-model="activeTab" class="loan-detail__tabs">
        <el-tab-pane label="Thông tin hồ sơ" name="info">
          <div class="section">
            <div class="section__title mt-6"><h6><b>I. Thông tin người vay</b></h6></div>
            <el-form :model="data" label-position="top" class="loan-form">
              <el-row :gutter="24">
                <el-col :xs="24" :sm="12" :md="6">
                  <el-form-item>
                    <span class="fw-semibold">Họ tên</span>
                    <el-input v-model="data.payer_name" :disabled="!is_edit" />
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6">
                  <el-form-item>
                    <span class="fw-semibold">Số điện thoại</span>
                    <el-input v-model="data.payer_phone" :disabled="!is_edit" />
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6">
                  <el-form-item>
                    <span class="fw-semibold">Email</span>
                    <el-input v-model="data.payer_email" :disabled="!is_edit" />
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6">
                  <el-form-item>
                    <span class="fw-semibold">Thời gian có thể nghe tư vấn</span>

                    <el-select
                        v-model="data.consultation_time_slot"
                        class="w-100"
                        placeholder="Chọn thời gian tư vấn"
                        :disabled="!is_edit"
                    >
                      <el-option
                          label="8:30 - 12:00"
                          value="MORNING"
                      />

                      <el-option
                          label="13:30 - 18:00"
                          value="AFTERNOON"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="24">
                <el-col :xs="24" :sm="24" :md="12">
                  <el-form-item>
                    <span class="fw-semibold">Địa chỉ</span>
                    <el-input v-model="data.payer_address" :disabled="!is_edit" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <div class="d-flex justify-content-end align-items-center mt-2">
              <el-button v-if="!is_edit" size="mini" class="text-white rounded" @click="is_edit=true" style="background-color: #5D04B0">Sửa thông tin người vay</el-button>
              <el-button v-if="is_edit" size="mini" class="rounded" @click="is_edit=false" style="background-color: #F5F7FA">Hủy</el-button>
              <el-button v-if="is_edit" size="mini" class="text-white rounded" @click="updateInfoBorrower()" style="background-color: #5D04B0">Xác nhận</el-button>
            </div>
          </div>

          <!-- II. Học viên -->
          <div class="section">
            <div class="section__title"><h6><b>II. Thông tin học viên</b></h6></div>

            <el-form :model="data" label-position="top" class="loan-form">
              <el-row :gutter="24">
                <el-col :xs="24" :sm="12" :md="6">
                  <el-form-item>
                    <span class="fw-semibold">Họ tên</span>
                    <el-input v-model="data.student_name" disabled />
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6">
                  <el-form-item>
                    <span class="fw-semibold">Số điện thoại</span>
                    <el-input v-model="data.student_phone" disabled />
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6">
                  <el-form-item>
                    <span class="fw-semibold">Mã học viên</span>
                    <el-input v-model="data.student_code + 100000" disabled />
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6">
                  <el-form-item>
                    <span class="fw-semibold">Trung tâm</span>
                    <el-input v-model="data.center_name" disabled />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>

          <!-- III. Hồ sơ -->
          <div class="section">
            <div class="section__title"><h6><b>III. Thông tin hồ sơ</b></h6></div>

            <el-form :model="data" label-position="top" class="loan-form">
              <el-row :gutter="24">
                <el-col :xs="24" :sm="12" :md="6">
                  <el-form-item>
                    <span class="fw-semibold">Thời gian đăng ký vay</span>
                    <el-input v-model="data.created_at" disabled />
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6">
                  <el-form-item>
                    <span class="fw-semibold">Combo đăng ký</span>
                    <el-input v-model="data.course_combo" disabled />
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6">
                  <el-form-item>
                    <span class="fw-semibold">Số tiền trả trước</span>
                    <el-input v-model="data.prepayment_percent ?? ''" disabled />
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6">
                  <el-form-item>
                    <span class="fw-semibold">Hợp đồng</span>
                    <el-input
                        v-model="data.edutalk_contract_id"
                        :readonly="true"
                        class="input-link"
                        @click.native="onClickContract(data)"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="24">
                <el-col :xs="24" :sm="12" :md="6">
                  <el-form-item>
                    <span class="fw-semibold">Thời gian trả góp</span>
                    <el-input v-model="data.loan_term_months + ' tháng'" disabled />
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6">
                  <el-form-item>
                    <span class="fw-semibold">Giá khóa học</span>
                    <el-input v-model="data.principal_amount" disabled />
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6">
                  <el-form-item>
                    <span class="fw-semibold">Tư vấn viên</span>
                    <el-input v-model="data.sale.name" disabled />
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6">
                  <el-form-item>
                    <span class="fw-semibold">Số điện thoại tư vấn viên</span>
                    <el-input v-model="data.sale.phone" disabled />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <div class="docs">
              <div>
                <div class="d-flex justify-content-between align-items-center docs__grid" >
                  <div class="docs__item" v-if="docs.idCard.length > 0">
                    <div class="docs__label">Căn cước công dân</div>
                    <div class="thumbs">
                      <el-image
                          style="width: 150px; height: 150px;"

                          v-for="(src, idx) in docs.idCard"
                          :key="'idCard-' + idx"
                          class="thumb mr-2"
                          :src="src"
                          :preview-src-list="docs.idCard"
                          fit="cover"
                      />
                    </div>
                  </div>
                  <div class="docs__item" v-if="docs.birthCert.length > 0">
                    <div class="docs__label">Giấy khai sinh</div>
                    <div class="thumbs">
                      <el-image
                          style="width: 150px; height: 150px;"
                          v-for="(src, idx) in docs.birthCert"
                          :key="'birth-' + idx"
                          class="thumb mr-2"
                          :src="src"
                          :preview-src-list="docs.birthCert"
                          fit="cover"
                      />
                    </div>
                  </div>
                  <div class="docs__item" v-if="docs.receipt.length > 0">
                    <div class="docs__label">Phiếu thu</div>
                    <div class="thumbs">
                      <el-image
                          style="width: 150px; height: 150px;"

                          v-for="(src, idx) in docs.receipt"
                          :key="'receipt-' + idx"
                          class="thumb mr-2"
                          :src="src"
                          :preview-src-list="docs.receipt"
                          fit="cover"
                      />
                    </div>
                  </div>
                  <div class="docs__item" v-if="docs.finance.length > 0">
                    <div class="docs__label">Chứng minh tài chính</div>
                    <div class="thumbs">
                      <el-image
                          style="width: 150px; height: 150px;"
                          v-for="(src, idx) in docs.finance"
                          :key="'finance-' + idx"
                          class="thumb mr-2"
                          :src="src"
                          :preview-src-list="docs.finance"
                          fit="cover"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end align-items-center mt-4" v-if="[1,2].includes(step)">
            <el-button @click="requestAdditionalVisible=true" style="background-color: #CACACA" class="rounded" size="mini">Yêu cầu bổ sung</el-button>
            <el-button @click="acceptFile()" style="background-color: #5D04B0" size="mini" class="rounded text-white">Xác nhận hồ sơ</el-button>
          </div>
        </el-tab-pane>

        <!-- TAB xử lý hồ sơ -->
        <el-tab-pane label="Xử lý hồ sơ" name="process">
            <HandleFileContact :step="step" @view-profile="activeTab='info'"></HandleFileContact>
        </el-tab-pane>

        <el-dialog
            title="Yêu cầu bổ sung hồ sơ"
            :visible.sync="requestAdditionalVisible"
            width="40%">
          <hr>
          <requestAdditionalDialog @close="requestAdditionalVisible=false"></requestAdditionalDialog>
        </el-dialog>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import {UPDATE_INFO_BORROWER, GET_INFO_BORROWER, ACCEPT_FILE_CITIME} from "../../../../core/services/store/customer/customer-crm.module";
import HandleFileContact from "./HandleFileContact.vue";
import RequestAdditionalDialog from "./requestAdditionalDialog.vue";

export default {
  name: "ContractDetail",
  components: {RequestAdditionalDialog, HandleFileContact},
  data() {
    return {
      is_edit: false,
      requestAdditionalVisible: false,
      activeTab: "info",
      step: 1,
      data: [],
      docs: {
        idCard: [],
        birthCert: [],
        receipt: [],
        finance: [],
      },
    };
  },
  mounted() {
    this.getInfoByContact()
  },
  methods: {
    getInfoByContact() {
      this.$store.dispatch(GET_INFO_BORROWER, {id: this.$route.params.id})
          .then((res) => {
            this.data = res.data;
            this.docs = this.mapDocs(this.data.documents);
            this.step = res.data.status;
          })
          .catch((error) => {

      });
    },

    mapDocs(documents = []) {
        const docs = {
          idCard: [],
          birthCert: [],
          receipt: [],
          finance: [],
        };

        documents.forEach((d) => {
          if (!d || !d.link) return;
          switch (d.type) {
            case 'IdFront':
              docs.idCard.push(d.link);
              break;
            case 'IdBack':
              docs.idCard.push(d.link);
              break;
            case 'BirthCertificate':
              docs.birthCert.push(d.link);
              break;
            case 'Invoice20Percent':
              docs.receipt.push(d.link);
              break;
            case 'FinancialProof':
              docs.finance.push(d.link);
              break;
          }
        });
        return docs;
    },

    acceptFile() {
      this.$store.dispatch(ACCEPT_FILE_CITIME, { id: this.$route.params.id })
          .then((res) => {
            this.$notify({
              title: 'Success',
              message: res.message ? res.message : 'Xác nhận hồ sơ thành công!',
              type: 'success'
            });
            this.step = Number(res.data.status);
            this.activeTab = 'process';
          })
          .catch((error) => {
            this.$notify({
              title: 'Error',
              message: 'Xác nhận hồ sơ thất bại!',
              type: 'error'
            });
          });
    },

    onClickContract(student) {
      if (!student.student_phone) {
        this.$notify({
          title: 'Error',
          message: 'Không tìm thấy hợp đồng liên kết với hồ sơ này do thiếu số điện thoại học viên!',
          type: 'error'
        });
        return;
      }

      const routeData = this.$router.resolve({
        path: '/contracts',
        query: { keyword: student.student_phone }
      });

      window.open(routeData.href, '_blank');
    },

    updateInfoBorrower() {
      const payload = {
        id: this.$route.params.id,
        phone: this.data.payer_phone,
        name: this.data.payer_name,
        email: this.data.payer_email,
        address: this.data.payer_address,
        consultation_time_slot: this.data.consultation_time_slot,
      }

      this.$store.dispatch(UPDATE_INFO_BORROWER, payload)
          .then((res) => {
            this.$notify({
              title: 'Success',
              message: res.message || 'Update thông tin người trả nợ thành công!',
              type: 'success'
            });
            this.is_edit = false;
          })
          .catch((e) => {
            this.$notify({
              title: 'Error',
              message: e.message || 'Update thông tin người trả nợ thất bại!',
              type: 'error'
            });
            this.is_edit = false;
          });
    },
  },
};
</script>

<style scoped>
@media (max-width: 750px) {
    .docs__grid {
        display: block !important;
    }
}

:deep .input-link .el-input__inner {
  color: #409EFF;
  text-decoration: underline;
  cursor: pointer;
  background: #f5f7fa;
}
</style>